import * as React from 'react'
import HotspotTeaserMolecule from 'theme/molecules/HotspotTeaser'
import * as t from 'theme/molecules/HotspotTeaser/types'

export default function HotspotTeaser(props: t.Props) {
  return <HotspotTeaserMolecule {...props} />
}
